// Mock Personnel Data - İNSANET
// Personel takibi ve yoklama verileri

const today = new Date();
const formatDateObj = (d) => d.toISOString().split('T')[0];
const daysAgo = (n) => { const d = new Date(today); d.setDate(d.getDate() - n); return formatDateObj(d); };

export const personnelRoles = [
    { key: 'insaat', label: 'İnşaat İşçisi', color: 'bg-info' },
    { key: 'boyaci', label: 'Boyacı', color: 'bg-warning' },
    { key: 'kalipci', label: 'Kalıpçı', color: 'bg-success' },
    { key: 'elektrikci', label: 'Elektrikçi', color: 'bg-tertiary' },
    { key: 'tesisatci', label: 'Tesisatçı', color: 'bg-secondary' },
    { key: 'usta', label: 'Usta', color: 'bg-primary' },
];

export const mockPersonnel = [
    // --- c1: Merkez Projesi personeli ---
    { id: 'per-1', constructionId: 'c1', name: 'Hasan Yıldırım', role: 'usta', phone: '0532 111 2233', dailyWage: 1200, status: 'active', startDate: '2024-06-15' },
    { id: 'per-2', constructionId: 'c1', name: 'Murat Demir', role: 'insaat', phone: '0533 222 3344', dailyWage: 800, status: 'active', startDate: '2024-08-01' },
    { id: 'per-3', constructionId: 'c1', name: 'Kemal Öz', role: 'insaat', phone: '0534 333 4455', dailyWage: 800, status: 'active', startDate: '2024-08-01' },
    { id: 'per-4', constructionId: 'c1', name: 'Ali Kara', role: 'kalipci', phone: '0535 444 5566', dailyWage: 950, status: 'active', startDate: '2024-07-10' },
    { id: 'per-5', constructionId: 'c1', name: 'Veli Güneş', role: 'kalipci', phone: '0536 555 6677', dailyWage: 950, status: 'active', startDate: '2024-09-01' },
    { id: 'per-6', constructionId: 'c1', name: 'Osman Ak', role: 'boyaci', phone: '0537 666 7788', dailyWage: 900, status: 'active', startDate: '2024-10-01' },
    { id: 'per-7', constructionId: 'c1', name: 'Salih Deniz', role: 'boyaci', phone: '0538 777 8899', dailyWage: 900, status: 'active', startDate: '2024-10-15' },
    // --- c2: Bağcılar Projesi personeli ---
    { id: 'per-8', constructionId: 'c2', name: 'Emre Yılmaz', role: 'elektrikci', phone: '0539 888 9900', dailyWage: 1100, status: 'active', startDate: '2024-11-01' },
    { id: 'per-9', constructionId: 'c2', name: 'Burak Aslan', role: 'tesisatci', phone: '0530 999 0011', dailyWage: 1050, status: 'active', startDate: '2024-11-10' },
    { id: 'per-10', constructionId: 'c2', name: 'Serkan Taş', role: 'insaat', phone: '0531 000 1122', dailyWage: 800, status: 'inactive', startDate: '2024-06-01' },
];

// Yoklama verileri (son 7 gün dinamik)
export const mockAttendance = {
    [daysAgo(0)]: { 'per-1': true, 'per-2': true, 'per-3': true, 'per-4': true, 'per-5': true, 'per-6': true, 'per-7': true, 'per-8': true, 'per-9': true },
    [daysAgo(1)]: { 'per-1': true, 'per-2': true, 'per-3': false, 'per-4': true, 'per-5': true, 'per-6': true, 'per-7': false, 'per-8': true, 'per-9': true },
    [daysAgo(2)]: { 'per-1': true, 'per-2': true, 'per-3': true, 'per-4': true, 'per-5': true, 'per-6': false, 'per-7': true, 'per-8': true, 'per-9': true },
    [daysAgo(3)]: { 'per-1': true, 'per-2': false, 'per-3': true, 'per-4': true, 'per-5': true, 'per-6': true, 'per-7': true, 'per-8': false, 'per-9': true },
    [daysAgo(4)]: { 'per-1': false, 'per-2': true, 'per-3': true, 'per-4': false, 'per-5': true, 'per-6': true, 'per-7': true, 'per-8': true, 'per-9': true },
};

// Helper fonksiyonlar

/**
 * Rol ve inşaat bazlı personel filtresi.
 * @param {string} role - 'all' veya belirli bir rol (usta, insaat, vb.)
 * @param {string|null} constructionId - null → tüm inşaatlar (showAllConstructions=true)
 */
export const getPersonnelByRole = (role, constructionId = null) => {
    return mockPersonnel.filter(p => {
        if (p.status !== 'active') return false;
        const matchesRole = !role || role === 'all' || p.role === role;
        const matchesConstruction = !constructionId || p.constructionId === constructionId;
        return matchesRole && matchesConstruction;
    });
};

export const getAttendanceForDate = (date) => {
    return mockAttendance[date] || {};
};

export const getPersonnelById = (id) => {
    return mockPersonnel.find(p => p.id === id);
};

export const getRoleLabel = (roleKey) => {
    return personnelRoles.find(r => r.key === roleKey)?.label || roleKey;
};

export const getRoleColor = (roleKey) => {
    return personnelRoles.find(r => r.key === roleKey)?.color || 'bg-neutral-400';
};

// İstatistikler
export const getPersonnelStats = (personnel, attendance) => {
    const activeCount = personnel.length;
    const presentToday = Object.values(attendance).filter(Boolean).length;

    return {
        activeCount,
        presentToday,
        absentToday: activeCount - presentToday,
    };
};

export default mockPersonnel;
